import _curry from "ramda/es/curry";
export default _curry(function (fn, x) {
  return fn(x).then(function () {
    return x;
  });
});